import Controller from "./editableTextarea.controller";
import template from "./editableTextarea.html";

const editableTextarea = {
  template,
  controller: Controller,
  bindings: {
    title: "@",
    showRemove: "@",
    name: "@",
    eventName: "<",
    selected: "=",
    hideEdit: "@",
    permissionName: "@",
    resourceMethodName: "@",
  },
};

export default editableTextarea;



// WEBPACK FOOTER //
// ./src/components/editableTextarea/editableTextarea.component.js